import React from 'react';
import { ContMenu } from './Menu.styles';
import ItemMenu from '../ItemMenu';
import { useTranslation } from 'react-i18next';
import { routes } from './data/routes';

const Menu = () => {
  const { i18n } = useTranslation();

  const currentRoutes = routes[i18n.language] || routes.es;

  return (
    <ContMenu>
      {currentRoutes.map((route, index) => (
        <ItemMenu
          key={index}
          text={route.text}
          linkTo={route.linkTo}
          type={route.type}
          showDropdown={route.showDropdown}
        />
      ))}
    </ContMenu>
  );
};

export default Menu;
